export default __webpack_public_path__ + "e17830a1f52811a3dd25914536b7bcf2.png";